
import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { GetUserResult, UserResetmail } from '../../models/UserModel';

import { LoginService } from '../../services/login.service';
 

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']

})


export class ForgotpasswordComponent  {
    userIdname : any ;
    userForm: FormGroup;
    userEmailAdddress : string;
    timestamp : any;
    private userResetMail : UserResetmail;
    userName :string;
    private  sofiaPreferencesURL : string = "%=%SOFIAURL%=%";
    navigationLink : string ="%=%LINK%=%";
    ResetUri : string ;
    ResetLink :string;
    userMessage : boolean =false ;
    userWarningMessage : boolean = false;
    userEmail : string;
    encryptUserDetail : GetUserResult;
    showResetButton : boolean;
    disableOnSubmit : boolean = true;

    @Input() username : string;
    
  
    constructor( 
      private formBuilder: FormBuilder,
      private loginService: LoginService,
      private  translate: TranslateService,
      private pipe: DatePipe
    ) {
      this.userResetMail = new UserResetmail();
      this.encryptUserDetail = new GetUserResult();
    }
    ngOnInit(): void {
 
        this.userForm = this.formBuilder.group({
          userIdname: ['', Validators.required]
        });
        this.userIdname =  this.username;
        this.onInputChange(this.userIdname);
      
        this.ResetUri =  environment.sofiaMailURL;
      }
      onInputChange(inpuData : string )
      {
        if(inpuData ===''|| inpuData=== undefined)
        {
          this.showResetButton= false;
        }
        else{
          this.showResetButton= true;
        }
      }
      SubmitUser()
      {

        
        this.userName = this.userForm.controls.userIdname.value;
        this.disableOnSubmit= false;
        if (this.userName !== (null || '') ) {
          this.loginService.GetUser(this.userName).subscribe(
             (data) => {
               if(data.LbSta=="EMAIL VALIDATION PENDING")
               {
                this.userWarningMessage = true;
               }
                 else
                    {
                      this.userMessage= true;
                    }
                    
              if(data.IdUsr != this.userName && data.LbSta =="FINAL" && data.TlAdrEmlUsr != (null|| ''))
              { 
                this.userEmail= data.TlAdrEmlUsr;
                  this.loginService.UserResetPassword(this.userName,"eMail").subscribe(
                  (data) => {
                    
                    if(  data.IntState=="Ok"  && data.TlPsw!=(null||''))
                    {
                      this.encryptUserDetail.NmCteUsr = this.userName;
                    this.encryptUserDetail.TlPsw = data.TlPsw;
                    this.encryptUserDetail.Languagecode =  sessionStorage.getItem("currentlang");
                      this.loginService.EncryptDetails(this.encryptUserDetail).subscribe(
                        (data) => {
                          
                          
                          if(  data!="Failed")
                          {

                                    this.userResetMail.Subject=this.translate.instant('ResetPasswordSubject_001');
                                    this.userResetMail.To =this.userEmail;  
                                    this.userResetMail.Body = this.translate.instant('ForgotPasswordMailContent_001');
                                    this.userResetMail.Language=  sessionStorage.getItem("currentlang");
                                    this.userResetMail.ContentType="text/html";
                                this.ResetLink= `${this.ResetUri}/app-reset-password?userName=${data.Username}&password=${data.TlPsw}&Timestamp=${data.TimeStamp}&Languagecode=${data.Languagecode}`;
                                   
                                this.userResetMail.Body= this.userResetMail.Body.replace(this.sofiaPreferencesURL,this.ResetLink);
                                this.userResetMail.Body= this.userResetMail.Body.replace(this.navigationLink,this.ResetLink);

                          this.loginService.SendEmail(this.userResetMail).subscribe(
                            (data)=>{

                            // Email sent succefully
                            this.userMessage= true;

                            }
                          );
                   
                        
                    }
                  });
                }
                   },
                   (err) => {
                    
                   }
                 );
              }
               
             },
             (err) => {
              
             }
           );
         } 
        //  else {
        //    //Displays when user enters Empty username or password
            
        //  }
       
        

       
       }
      }
      
    
